import { render, staticRenderFns } from "./SyncListTable.vue?vue&type=template&id=da12f136&scoped=true"
import script from "./SyncListTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./SyncListTable.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SyncListTable.vue?vue&type=style&index=0&id=da12f136&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da12f136",
  null
  
)

export default component.exports